/*
 * Author： BigFaceMaster
 * Create Time: 2018-11-27
 * Description: Loading BMap
 * CopyRight: @BigFaceMaster
 * */

(function(root, factory) {
  
  if(root === null) {
    throw new Error('BMap can be used only in browser');
  }
  
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.BMapLoader = factory();
  }
})(typeof window !== 'undefined' ? window : null, function() {

  'use strict';

  let BMapVersion = '2.0';
  let script = null;
  let BMap = null;
  let loading = false;
  let callbacks = [];
  let onLoadEvents = [];
  let originalCreateLoaderMethod = null;
  let BMapLoader = {};

  BMapLoader.URL = 'http://api.map.baidu.com/api';
  BMapLoader.ak = null;
  BMapLoader.VERSION = BMapVersion;
  BMapLoader.WINDOW_CALLBACK_NAME = 'bmap_initialize';
  BMapLoader._baiduMockApiObject = {};

  BMapLoader.apiLoad = function(fn) {
    if (BMap === null) {
      if (loading === true) {
        if (fn) {
          callbacks.push(fn)
        }
      } else {
        loading = true;

        window[BMapLoader.WINDOW_CALLBACK_NAME] = function() {
          ready(fn)
        };

        BMapLoader.createLoader();
      }
    } else if (fn) {
      fn(BMap)
    }
  };


  BMapLoader.createLoader = function() {
    script = document.createElement('script');
    script.src = BMapLoader.createUrl();

    document.body.appendChild(script);
  };


  BMapLoader.isLoaded = function() {
    return BMap !== null;
  };

  BMapLoader.createUrl = function() {
    return BMapLoader.URL + '?v=' + BMapLoader.VERSION + '&ak=' + BMapLoader.ak + '&callback=' + BMapLoader.WINDOW_CALLBACK_NAME;
  };


  BMapLoader.release = function(fn) {
    const release = function() {
      BMapLoader.ak = null;
      BMapLoader.VERSION = BMapVersion;

      BMap = null;
      loading = false;
      callbacks = [];
      onLoadEvents = [];

      if (typeof window.BMap !== 'undefined') {
        delete window.BMap;
      }

      if (typeof window[BMapLoader.WINDOW_CALLBACK_NAME] !== 'undefined') {
        delete window[BMapLoader.WINDOW_CALLBACK_NAME]
      }

      if (originalCreateLoaderMethod !== null) {
        BMapLoader.createLoader = originalCreateLoaderMethod;
        originalCreateLoaderMethod = null;
      }

      if (script !== null) {
        script.parentElement.removeChild(script);
        script = null;
      }

      if (fn) {
        fn();
      }
    };

    if (loading) {
      BMapLoader.apiLoad(() => {
        release();
      })
    } else {
      release();
    }
  };

  BMapLoader.onLoad = function(fn) {
    onLoadEvents.push(fn);
  };

  BMapLoader.makeMock = function() {
    originalCreateLoaderMethod = BMapLoader.createLoader;

    BMapLoader.createLoader = function() {
      window.google = BMapLoader._baiduMockApiObject;
      window[BMapLoader.WINDOW_CALLBACK_NAME]();
    };
  };

  let ready = function(fn) {

    loading = false;

    if (BMap === null) {
      BMap = window.BMap;
    }

    for (let i = 0; i < onLoadEvents.length; i++) {
      onLoadEvents[i](BMap);
    }

    if (fn) {
      fn(BMap);
    }

    for (let i = 0; i < callbacks.length; i++) {
      callbacks[i](BMap);
    }

    callbacks = [];
  };

  return BMapLoader;
});
